import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyBy } from '../../../../../helpers/common'
import BalanceBreakdownEachYear from '../../common/balanceBreakdown/EachYear'
import {
  getNoDataComponent,
  getYearTabs,
  handleIconDownload,
} from '../../helper'
import { changeYear, selectYear } from '../../store/slice'
import { EACH_YEAR } from './constant'
import {
  selectByIdTable,
  selectDataViewByEachYear,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const totalId = 'BS64'
const totalAssetsId = 'FA152'

export const EachYear = ({
  id,
  isDynamicReport,
  year: yearSetting,
  chart = [],
  isDownloadComponent,
}) => {
  const dispatch = useDispatch()

  const year = useSelector(selectYear(id, yearSetting))
  const dataByIdTable = useSelector(selectByIdTable)
  const data = useSelector(selectDataViewByEachYear(year))
  const dataById = keyBy(data, 'id')
  const indicatorById = useSelector(selectIndicatorById)
  const years = useSelector(selectYears)

  const tabs = getYearTabs(years)

  const setYear = (year) => dispatch(changeYear({ id, year }))

  useEffect(() => {
    if (
      (tabs.length && !year) ||
      !tabs.map((item) => item.key).includes(String(year))
    ) {
      setYear(tabs[tabs.length - 1]?.key)
    }
  }, [tabs.length, year])

  const barChartData = EACH_YEAR.ASSETS.map((item) => ({
    name: indicatorById[item.id]?.ratioName,
    value: dataById[item.id]?.value * 100,
    color: item.color,
  }))

  const totalParentPieValue = EACH_YEAR.PARENT_PIE.reduce(
    (prev, curr) => prev + dataByIdTable[curr.id]?.[year],
    0,
  )
  const parentPieData = EACH_YEAR.PARENT_PIE.map((item) => ({
    id: item.id,
    name: indicatorById[item.id]?.ratioName,
    value: (dataByIdTable[item.id]?.[year] / totalParentPieValue) * 100,
    color: item.color,
  }))

  const childPieData = EACH_YEAR.PARENT_PIE.reduce((prev, curr) => {
    return {
      ...prev,
      [curr.id]: EACH_YEAR.CHILD_PIE[curr.id].map((item) => ({
        name: indicatorById[item.id]?.ratioName,
        value: dataById[item.id]?.value * 100,
        color: item.color,
      })),
    }
  }, {})

  const valueTotal = dataByIdTable[totalId]
    ? dataByIdTable[totalId]?.[year]
    : null

  const dataContainTotalAssetsOnly =
    data?.length === 1 && data[0]?.id === totalAssetsId

  const isNoData = !data?.length || dataContainTotalAssetsOnly

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (!year) return getNoDataComponent(isDynamicReport)

  return (
    <BalanceBreakdownEachYear
      data={barChartData}
      dataPieParent={parentPieData}
      dataPieChild={childPieData}
      tabs={tabs}
      onChangeTab={setYear}
      isNoData={isNoData}
      valueTotal={valueTotal}
      year={year}
      isDynamicReport={isDynamicReport}
      isDownloadComponent={isDownloadComponent}
      chart={chart}
    />
  )
}
